/* VAR_MARK_FIXS7=3638ab99-e */
/* k4k-chat-guard.js (Boardroom Step 3, 25 Oct 2026, PREVIEW first).
   Boardroom fixes6 (27 Oct 2026): pack tiles and per-unit prices in the guard.
   Boardroom fixes7e (29 Oct 2026, approved by Jonathan 09:38 GMT): lift the bubble via --k4k-chat-clear to stay clear of
   pack tiles, per-unit prices, product buy controls and the open cookie banner, instead of hiding on arrival. Hide only if
   a lift cannot clear a hard control. Unchanged at 1440 when nothing overlaps.
   To remove: delete this file and its <script> line in layout/theme.liquid (and related CSS in k4k-preview.css). */
(function(){/*CDNBUST:1793275586*/
  var mq=window.matchMedia('all'),root=document.documentElement,raf=0,clear=0;
  var PACK='main .k4k-wc__pack,main .k4k-qb__pack,main .k4k-wc__each2,main .k4k-wc__tot,main .k4k-qb__pack-price,main .k4k-qb__pack-per';
  var HARD='.product__info-container .loop-widget-container,.product__info-container .k4k-qtyrow,.product__info-container .product-form__quantity,.product__info-container product-form button[type="submit"],.product__info-container .shopify-payment-button,.k4k-hb__price,.k4k-hb__form button,.k4k-atc__btn,main .quick-add__submit';
  function findPart(n,d){
    if(!n||d>4)return null;
    var sr=n.shadowRoot;if(!sr)return null;
    var a=sr.querySelector('[part~="activator"]');if(a)return a;
    var kids=sr.querySelectorAll('*');
    for(var i=0;i<kids.length;i++){if(kids[i].shadowRoot){var r=findPart(kids[i],d+1);if(r)return r;}}
    return null;
  }
  function chatRect(){
    var host=document.querySelector('shopify-chat');if(!host)return null;
    var a=findPart(host,0);
    var r=a&&a.getBoundingClientRect();
    if(r&&r.width>0&&r.height>0)return r;
    var h=host.getBoundingClientRect();
    if(h.width>0&&h.height>0&&h.height<200)return h;
    return null;
  }
  function hit(a,b,pad){
    /* Geometric overlap, then keep right-column tiles (left past 40vw). Full-bleed rows
       (price/payment wrappers starting near the left edge) only count when they cover most
       of the chat bubble horizontally — so left packs stay ignored, right packs (L~199 on
       phone) lift, and a payment button sitting under the activator still clears. */
    if(!(a.left<b.right+pad&&a.right>b.left-pad&&a.top<b.bottom+pad&&a.bottom>b.top-pad))return false;
    if(b.left>window.innerWidth*0.40)return true;
    var ow=Math.min(a.right,b.right)-Math.max(a.left,b.left);
    return ow>=a.width*0.6;
  }
  function setClear(px){
    px=Math.max(0,Math.round(px));
    if(px===clear)return;
    clear=px;
    root.style.setProperty('--k4k-chat-clear',clear+'px');
  }
  function bannerTop(){
    var b=document.getElementById('shopify-pc__banner');if(!b)return null;
    var cs=getComputedStyle(b);if(cs.display==='none'||cs.visibility==='hidden')return null;
    var r=b.getBoundingClientRect();return r.height>0?r.top:null;
  }
  function needLift(c,sel,pad){
    var els=document.querySelectorAll(sel),vh=window.innerHeight,need=0,i,e,r,lift;
    for(i=0;i<els.length;i++){
      e=els[i];if(e.closest('[hidden]'))continue;
      r=e.getBoundingClientRect();
      if(r.width===0||r.bottom<0||r.top>vh)continue;
      if(hit(c,r,pad)){lift=Math.ceil(c.bottom-r.top+pad);if(lift>need)need=lift;}
    }
    return need;
  }
  function stillHit(c,sel,pad){
    var els=document.querySelectorAll(sel),vh=window.innerHeight,i,e,r;
    for(i=0;i<els.length;i++){
      e=els[i];if(e.closest('[hidden]'))continue;
      r=e.getBoundingClientRect();
      if(r.width===0||r.bottom<0||r.top>vh)continue;
      if(hit(c,r,pad))return true;
    }
    return false;
  }
  function check(){
    raf=0;
    var off=false,lift=0,c=chatRect(),nat,bt,maxLift,lifted,n1,n2,need,iter,cur,above;
    if(mq.matches&&c){
      nat={left:c.left,right:c.right,top:c.top+clear,bottom:c.bottom+clear,width:c.width,height:c.height};
      /* Keep the bubble on-screen under the sticky header */
      maxLift=Math.max(0,Math.floor(nat.bottom-8-nat.height));
      /* Iterative lift: clearing a lower control (payment/qty) can move the bubble into
         pack tiles above — re-measure after each step and keep lifting until clear or max. */
      for(iter=0;iter<6;iter++){
        cur={left:nat.left,right:nat.right,top:nat.top-lift,bottom:nat.bottom-lift,width:nat.width,height:nat.height};
        n1=needLift(cur,PACK,6);
        n2=needLift(cur,HARD,6);
        need=n1>n2?n1:n2;
        bt=bannerTop();
        if(bt!==null){above=Math.ceil(cur.bottom-bt+12);if(above>need)need=above;}
        if(need<=0)break;
        lift+=need;
        if(lift>=maxLift){lift=maxLift;break;}
      }
      setClear(lift);
      lifted={left:nat.left,right:nat.right,top:nat.top-lift,bottom:nat.bottom-lift,width:nat.width,height:nat.height};
      /* Hide if hard buy controls or pack tiles still overlap after the max useful lift (0 overlaps). */
      if(stillHit(lifted,HARD,6)||stillHit(lifted,PACK,6))off=true;
    } else {setClear(0);}
    if(root.classList.contains('k4k-chat-off')!==off)root.classList.toggle('k4k-chat-off',off);
  }
  function q(){if(!raf)raf=requestAnimationFrame(check);}
  window.addEventListener('scroll',q,{passive:true});
  window.addEventListener('resize',q);
  mq.addEventListener?mq.addEventListener('change',q):mq.addListener(q);
  new MutationObserver(q).observe(root,{attributes:true,attributeFilter:['class','style']});
  var tries=0,iv=setInterval(function(){q();if(++tries>40)clearInterval(iv);},400);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',q);else q();
})();
